
import { FUND_SELECTION_SET_VALUE } from '../../../actions/fundDeclarations/fundDeclarations';
import { fundDeclarationFieldTracking } from './fundDeclaration';

export const fundDeclarationTracking = (store, next, action) => {
    if (action.type === FUND_SELECTION_SET_VALUE) {
        return fundDeclarationFieldTracking(store, next, action);
    }
};
